import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  Box,
  ButtonBase,
  Menu,
  MenuItem,
  Typography,
  makeStyles,
} from '@material-ui/core'
import LanguageIcon from '@material-ui/icons/Language'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    cursor: 'pointer',
    padding: theme.spacing(0.5, 1),
    borderRadius: theme.shape.borderRadius,
    '&:hover': {
      backgroundColor: 'rgba(255,255,255,0.12)',
    },
  },
  label: {
    fontSize: 13,
    fontWeight: 500,
    letterSpacing: 0.5,
  },
  menuPaper: {
    borderRadius: 12,
    boxShadow: '0 8px 32px rgba(0,0,0,0.16)',
    minWidth: 120,
  },
  menuItem: {
    minWidth: 120,
  },
  activeItem: {
    color: theme.palette.secondary.main,
    fontWeight: 700,
  },
}))

const LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'zh', label: '中文' },
]

const LanguageSwitcher = ({ color = 'inherit' }) => {
  const classes = useStyles()
  const { i18n } = useTranslation()
  const [open, setOpen] = useState(false)
  const [anchorPos, setAnchorPos] = useState(null)

  const currentLang = LANGUAGES.find((l) => l.code === i18n.language) || LANGUAGES[0]

  const handleOpen = (e) => {
    const navBottom = document.querySelector('header')?.getBoundingClientRect()?.bottom ?? 56
    const rect = e.currentTarget.getBoundingClientRect()
    setAnchorPos({ top: navBottom, left: (rect.left + rect.right) / 2 })
    setOpen(true)
  }

  const handleChange = (code) => {
    i18n.changeLanguage(code)
    setOpen(false)
  }

  return (
    <>
      <Box
        component={ButtonBase}
        className={classes.root}
        onClick={handleOpen}
        style={{ color }}
      >
        <LanguageIcon fontSize='small' />
        <Typography className={classes.label} style={{ color }}>
          {currentLang.label}
        </Typography>
      </Box>
      <Menu
        anchorReference="anchorPosition"
        anchorPosition={anchorPos || { top: 56, left: 0 }}
        open={open}
        onClose={() => setOpen(false)}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
        getContentAnchorEl={null}
        style={{ zIndex: 1400 }}
        PaperProps={{ className: classes.menuPaper }}
      >
        {LANGUAGES.map((lang) => (
          <MenuItem
            key={lang.code}
            className={classes.menuItem}
            selected={lang.code === i18n.language}
            onClick={() => handleChange(lang.code)}
          >
            <Typography
              variant='body2'
              className={lang.code === i18n.language ? classes.activeItem : ''}
            >
              {lang.label}
            </Typography>
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}

export default LanguageSwitcher
